import { isNil } from "lodash";

import { Precision } from "../../../../types";
import calendarTypes from "../../../../types/calendarTypes";
import dateByAddingSpan from "./dateByAddingSpan";
import dateSubtractionFunctions from "./dateSubtractionFunctions";
import dateWithTimestamp from "./dateWithTimestamp";
import { timespanForPrecisionAndUnits,timespanToApproximateSeconds } from "./timespanFunctions";

const isTimespanLegalForCalendarType = (calendarType, timespan) => {
  switch (calendarType) {
    case calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME:
      return timespan.years === 0 && timespan.months === 0;
    case calendarTypes.CALENDAR_TYPE_DAY_TIME:
      return timespan.years === 0 && timespan.months === 0 && timespan.weeks === 0;
    case calendarTypes.CALENDAR_TYPE_HOUR_TIME:
      return timespan.years === 0 && timespan.months === 0 && timespan.weeks === 0 && timespan.days === 0;
    default:
      return true;
  }
};

export default (start, duration, calendar) => {
  if (!duration || isTimespanLegalForCalendarType(calendar.calendarType, duration)) {
    return duration;
  }
  const hasStartDate = !isNil(start.timestamp);
  let startDate = null;
  let endDate = null;
  if (hasStartDate) {
    startDate = start;
    endDate = dateByAddingSpan(calendar, startDate, duration);
  } else {
    startDate = dateWithTimestamp(calendar, calendar.zeroDateTimestamp, Precision.Auto);
    const seconds = timespanToApproximateSeconds(calendar, duration);
    endDate = dateByAddingSpan(calendar, startDate, timespanForPrecisionAndUnits(Precision.Second, seconds));
  }
  return dateSubtractionFunctions.timespanBetweenDates(calendar, startDate, endDate);
};
